import React, { FC, useEffect, useRef } from "react";
import styles from "./dragable.module.css";

const DragableComp = ({
  containerRef,
  children,
  initialX,
  initialY,
  resize,
}) => {
  const boxRef = useRef(null);

  const isClicked = useRef(false);

  const coords = useRef({
    startX: 0,
    startY: 0,
    lastX: initialX,
    lastY: initialY,
  });

  useEffect(() => {
    if (!boxRef.current || !containerRef?.current || resize) return;
    const box = boxRef.current;
    const container = containerRef?.current;

    const onMouseDown = (e) => {
      isClicked.current = true;
      coords.current.startX = e.clientX;
      coords.current.startY = e.clientY;
    };

    const onMouseUp = (e) => {
      isClicked.current = false;
      coords.current.lastX = box.offsetLeft;
      coords.current.lastY = box.offsetTop;
    };

    const onMouseMove = (e) => {
      if (!isClicked.current) return;

      // console.log("x",e.clientX - coords.current.startX + coords.current.lastX);
      // console.log("y",e.clientY - coords.current.startY + coords.current.lastY);

      const nextX = e.clientX - coords.current.startX + coords.current.lastX;
      const nextY = e.clientY - coords.current.startY + coords.current.lastY;

      box.style.top = `${nextY}px`;
      box.style.left = `${nextX}px`;
    };

    // box.addEventListener('mousedown', onMouseDown);
    // box.addEventListener('mouseup', onMouseUp);
    // container.addEventListener('mousemove', onMouseMove);
    // container.addEventListener('mouseleave', onMouseUp);

    box.addEventListener("pointerdown", onMouseDown);
    box.addEventListener("pointerup", onMouseUp);
    container.addEventListener("pointermove", onMouseMove);
    container.addEventListener("pointerleave", onMouseUp);

    const cleanup = () => {
      // box.removeEventListener('mousedown', onMouseDown);
      // box.removeEventListener('mouseup', onMouseUp);
      // container.removeEventListener('mousemove', onMouseMove);
      // container.removeEventListener('mouseleave', onMouseUp);

      box.removeEventListener("pointerdown", onMouseDown);
      box.removeEventListener("pointerup", onMouseUp);
      container.removeEventListener("pointermove", onMouseMove);
      container.removeEventListener("pointerleave", onMouseUp);
    };

    return cleanup;
  }, [resize]);

  return (
    <div ref={boxRef} className={styles.box}>
      {children}
    </div>
  );
};

export default DragableComp;
